import { OperationKeys, OperationSpecialQueryType, OperationType } from './enums';
export const OPERATION_TYPES = [
    OperationType.ALL,
    OperationType.PERMISSION,
    OperationType.FILE,
    OperationType.SETTING,
];
export const NORMAL = [
    OperationKeys.UPDATE_SPACE_FIELD_SETTING,
    OperationKeys.QUIT_SHARE_FROM_SPACE,
];
export const ONLY_FOLDER_NAME = [
    OperationKeys.OPEN_FOLDER_FAMILY_EXPANSION,
    OperationKeys.CLOSE_FOLDER_FAMILY_EXPANSION,
    OperationKeys.OPEN_FOLDER_AUTO_COLLECTION,
    OperationKeys.CLOSE_FOLDER_AUTO_COLLECTION,
    OperationKeys.OPEN_FOLDER_FAMILY_LABEL,
    OperationKeys.CLOSE_FOLDER_FAMILY_LABEL,
    OperationKeys.COPY_FOLDER_IN_SAME_SPACE,
    OperationKeys.COPY_FOLDER_FROM_OTHER_SPACE,
    OperationKeys.RESTORE_FOLDER_FROM_RECYCLE_BIN,
    OperationKeys.QUIT_SHARE_FROM_FOLDER,
];
export const ONLY_TEAM_NAME = [
    OperationKeys.ADD_SPACE_GROUP_SHARE,
    OperationKeys.DELETE_SPACE_GROUP_SHARE,
    OperationKeys.ADD_FOLDER_GROUP_SHARE,
    OperationKeys.DELETE_FOLDER_GROUP_SHARE,
];
export const DO_PATENT_IN_SAME_SPACE = [
    OperationKeys.MOVE_PATENT_IN_SAME_SPACE,
    OperationKeys.COPY_PATENT_IN_SAME_SPACE,
];
export const DO_FOLDER_COMMENT = [
    OperationKeys.CREATE_FOLDER_COMMENT,
    OperationKeys.UPDATE_FOLDER_COMMENT,
    OperationKeys.DELETE_FOLDER_COMMENT,
];
export const DO_PATENT_SOMETHING = [
    OperationKeys.ADD_NEW_PATENT,
    OperationKeys.IMPORT_NEW_PATENT,
    OperationKeys.MANUAL_COLLECT_PATENT,
    OperationKeys.AUTO_COLLECT_PATENT,
    OperationKeys.AUTO_EXPANSION_PATENTS,
    OperationKeys.MANUAL_EXPANSION_PATENTS,
    OperationKeys.MOVE_PATENT_FROM_OTHER_SPACE,
    OperationKeys.COPY_PATENT_FROM_OTHER_SPACE,
    OperationKeys.RESTORE_PATENT_FROM_RECYCLE_BIN,
    OperationKeys.DELETE_PATENT,
    OperationKeys.MOVE_PATENT_TO_OTHER_SPACE,
];
export const SAVE_PATENT_WITH_QUERY = [
    OperationKeys.AUTO_COLLECT_PATENT_BY_QUERY,
    OperationKeys.MANUAL_COLLECT_PATENT_BY_QUERY,
    OperationKeys.ADD_NEW_PATENT_BY_QUERY,
];
export const DO_FOLDER_GROUP_SHARE = [
    OperationKeys.ADD_FOLDER_USER_SHARE,
    OperationKeys.DELETE_FOLDER_USER_SHARE,
];
export const DO_USER_SHARE_MAP = [
    OperationKeys.UPDATE_SPACE_USER_SHARE,
    OperationKeys.UPDATE_FOLDER_USER_SHARE,
    OperationKeys.UPDATE_FOLDER_GROUP_SHARE,
    OperationKeys.UPDATE_SPACE_GROUP_SHARE,
];
export const DO_USER_NAMES = [
    OperationKeys.ADD_SPACE_USER_SHARE,
    OperationKeys.DELETE_SPACE_USER_SHARE,
    OperationKeys.ADD_COMPANY_SPACE_ADMIN,
    OperationKeys.DELETE_COMPANY_SPACE_ADMIN,
];
export const DO_FOLDER_NAMES = [
    OperationKeys.DELETE_FOLDER,
    OperationKeys.MOVE_FOLDER_FROM_OTHER_SPACE,
    OperationKeys.MOVE_FOLDER_TO_OTHER_SPACE,
];
export const SPECIAL_QUERY_TYPES = [
    OperationSpecialQueryType.SEMANTIC,
    OperationSpecialQueryType.BULK,
];
